import { gql } from '@apollo/client';

export const GET_AVAILABLE_INTERVIEWER = gql`
  query GetAvailableInterviewer($input: GetAvailableInterviewerInput!) {
    getAvailableInterviewer(input: $input) {
      id
      firstName
      lastName
      storeDetails {
        id
        avatarURL
      }
    }
  }
`;

export const GET_AVAILABLE_INTERVIEWERS = gql`
  query getAvailableInterviewers($input: GetAvailableInterviewersInput!) {
    getAvailableInterviewers(input: $input) {
      id
      firstName
      lastName
      storeDetails {
        id
        avatarURL
      }
    }
  }
`;

export const GET_AVAILABLE_SCHEDULE_SLOTS = gql`
  query GetAvailableScheduleSlots($input: GetAvailableScheduleSlotsInput!) {
    getAvailableScheduleSlots(input: $input) {
      slots {
        startTs
        endTs
      }
      schedule {
        slotStepMinutes
        store {
          id
          storeDetails {
            id
            storeName
            avatarURL
          }
        }
      }
      earliestAlternativeRange {
        month {
          from
          to
        }
      }
    }
  }
`;

export const GET_ALL_AVAILABLE_SCHEDULE_SLOTS = gql`
  query GetAllAvailableScheduleSlots(
    $input: GetAllAvailableSchedulesSlotsInput!
  ) {
    getAllAvailableScheduleSlots(input: $input) {
      slots {
        startTs
        endTs
        userId
      }
      schedules {
        slotStepMinutes
        store {
          id
          storeDetails {
            id
            storeName
            avatarURL
          }
        }
      }
      earliestAlternativeRange {
        month {
          from
          to
        }
      }
    }
  }
`;

export const GET_STORES_BY_HOST_ID = gql`
  query GetStoresByHostId($input: StoresFilterInput) {
    stores(input: $input, storeRoles: [Athlete, Organization, ContentCreator]) {
      entities {
        id
        lastName
        firstName
        storeDetails {
          id
          storeName
          avatarURL
        }
        sports {
          id
          name
        }
      }
      total
      offset
      limit
    }
  }
`;

export const GET_STORE_BY_HOST_ID = gql`
  query GetStoreByHostId(
    $input: StoreGetInput!
    $withFollowerCount: Boolean = false
  ) {
    store(input: $input) {
      id
      slug
      lastName
      firstName
      role
      audience
      followerCount @include(if: $withFollowerCount)
      storeDetails {
        id
        storeName
        avatarURL
      }
      sports {
        id
        name
      }
    }
  }
`;

export const GET_UPCOMING_INTERVIEW = gql`
  query GetUpcomingInterview {
    upcomingInterview {
      id
      interviewer {
        id
        storeDetails {
          id
          storeName
        }
      }
    }
  }
`;

export const SOONEST_UPCOMING_INTERVIEW = gql`
  query SoonestUpcomingInterview($input: UpcomingInterviewsInput!) {
    soonestUpcomingInterview(input: $input) {
      entities {
        id
        status
        creationType
        createdAt
        updatedAt
        streamCohostToken
        source {
          type
          ... on InterviewSourcePPVParticipant {
            id
            stream {
              id
              slug
              name
              description
              imageURL
              isPurchased
              streamStatus
              store {
                id
                slug
              }
            }
          }
          ... on InterviewSourceMerch {
            id
            merch {
              id
              title
              description
              mainImageUrl
              store {
                id
                slug
              }
            }
          }
          ... on InterviewSourceMemorabilia {
            id
            product {
              id
              title
              description
              images {
                url
                isMainImage
              }
              store {
                id
                slug
              }
            }
          }
        }
        stream {
          id
          slug
          isPurchased
          streamStatus
          store {
            id
            slug
          }
          scheduleDate
          scheduleDateUtc
          scheduleDateTz
          isInterview
        }
        interviewer {
          id
          avatarUrl
          firstName
          lastName
          storeDetails {
            id
          }
        }
        interviewee {
          id
          avatarUrl
          firstName
          lastName
        }
      }
      total
      offset
      limit
    }
  }
`;

export const GET_INTERVIEW = gql`
  query GetInterview($input: GetInterviewTaskInput!) {
    getInterview(input: $input) {
      id
      guestNotes
      adminNotes
      notes
      streamCohostToken
      interviewer {
        id
        slug
        firstName
        lastName
        storeDetails {
          storeName
          avatarURL
        }
      }
      interviewee {
        id
        slug
        firstName
        lastName
        storeDetails {
          storeName
          avatarURL
          instagramLink
          twitterLink
          facebookLink
          tiktokLink
          youtubeLink
        }
      }
      source {
        id
        type
        ... on InterviewSourcePPVParticipant {
          stream {
            id
            slug
            name
            scheduleDate
            scheduleDateUtc
            imageURL
            store {
              id
              slug
            }
          }
        }
      }
      stream {
        id
        name
        streamStatus
        scheduleDateUtc
        scheduleDateTz
        imageURL
        slug
        isHidden
        chatEnabled
        store {
          id
          slug
        }
      }
      scheduleEvent {
        id
        guestTimezone
        startTs
        endTs
      }
      status
      chatEnabled
      questions {
        id
        questionText
        topicName
        topicGroup
        isCustom
      }
    }
  }
`;

export const GET_INTERVIEW_IMAGE_STATE = gql`
  query GetInterviewImageState($input: GetInterviewImageStateInput!) {
    getInterviewImageState(input: $input) {
      id
      imageStatus
    }
  }
`;

export const GET_NOT_REVIEWED_INTERVIEW_ANSWER_VIDEOS = gql`
  query GetNotReviewedInterviewAnswerVideos(
    $input: GetNotReviewedVideosInput!
  ) {
    getNotReviewedInterviewAnswerVideos(input: $input) {
      id
      title
      body
      key
      videoUrl
      thumbnailUrl
      postCandidateStatus
      interviewQuestion {
        id
        questionText
        topicName
        topicGroup
        interview {
          id
        }
      }
    }
  }
`;

export const GET_NOT_REVIEWED_ANY_AI_CLIP_CANDIDATES = gql`
  query GetNotReviewedAnyAiClipCandidates(
    $input: GetNotReviewedAiClipCandidatesInput!
  ) {
    getNotReviewedAnyAiClipCandidates(input: $input) {
      id
      title
      topic
      description
      transcriptExcerpt
      score
      postCandidateStatus
      imageStatus
      clipUrl
      thumbnailUrl
      createdAt
    }
  }
`;

export const CAN_SCHEDULE_INTERVIEW = gql`
  query CanScheduleInterview($input: CanScheduleInterviewInput!) {
    canScheduleInterview(input: $input) {
      canCreateInterviewNow
    }
  }
`;
